<template>
  <div>
    <ContentHeader title="Update Configuration" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-primary">
              <form @submit.prevent="handleUpdateData()">
                <div class="card-body">
                  <div class="form-group">
                    <label for="name">Agent Level</label>
                    <div class="form-control bg-grey w-100">
                        <span v-if="payload.ib_level == 'INTRODUCING_BROKER'">Agent Level</span>
                        <span v-else-if="payload.ib_level == 'PARTNER_IB'">Supervisor Area</span>
                        <span v-else-if="payload.ib_level == 'MASTER_IB'">Manager Area</span>
                    </div>
                    <input type="hidden" disabled class="form-control"
                      name="ib_level"
                      v-model="payload.ib_level"
                      :class="{ 'border-danger': $v.payload.ib_level.$error }">
                    <!-- <select
                      class="form-control"
                      name="ib_level"
                      v-model="payload.ib_level"
                      :class="{ 'border-danger': $v.payload.ib_level.$error }"
                    >
                      <option value="MASTER_IB" selected>MASTER IB</option>
                      <option value="PARTNER_IB">PARTNER IB</option>
                      <option value="INTRODUCING_BROKER">
                        Agent
                      </option>
                    </select> -->
                    <div class="text-danger" v-if="$v.payload.ib_level.$error">
                      <small>Agent Level Required</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="min_investor">Minimum Investor</label>
                    <input
                      type="number"
                      class="form-control"
                      id="min_investor"
                      :class="{
                        'border-danger':
                          $v.payload.min_investor.$error ||
                          !$v.payload.min_investor.numeric,
                      }"
                      placeholder="Input Min Investor"
                      v-model="payload.min_investor"
                    />
                    <div
                      class="text-danger"
                      v-if="
                        $v.payload.min_investor.$error &&
                        !$v.payload.min_investor.required
                      "
                    >
                      <small>Min Investor Required</small>
                    </div>
                    <div
                      class="text-danger"
                      v-if="!$v.payload.min_investor.numeric"
                    >
                      <small>This Field must be a Number</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="min_deposit">Minimum Deposit</label>
                    <input
                      type="text"
                      class="form-control"
                      id="min_deposit"
                      placeholder="Input Min Deposit"
                      v-model="payload.min_deposit"
                      :class="{
                        'border-danger': $v.payload.min_deposit.$error,
                      }"
                    />
                    <div
                      class="text-danger"
                      v-if="
                        $v.payload.min_deposit.$error &&
                        !$v.payload.min_deposit.required
                      "
                    >
                      <small>Min Deposit Required</small>
                    </div>
                    <div
                      class="text-danger"
                      v-if="!$v.payload.min_deposit.numeric"
                    >
                      <small>This Field must be a Number</small>
                    </div>
                  </div>
                </div>
                <div class="row p-2 p-md-3 footer-card">
                  <div class="col-12 col-md-6 p-1">
                  <router-link
                    type="submit"
                    to="/configuration"
                    class="btn btn-outline-danger btn-block"
                  >
                    Cancel
                  </router-link>
                  </div>
                  <div class="col-12 col-md-6 p-1">
                    <button
                    type="submit"
                    href="#"
                    class="btn btn-success btn-block"
                    :disabled="submitStatus === 'PENDING'"
                  >
                    Update Configuration
                  </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiClient from "@/services/ApiServices";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      payload: {
        ib_level: "",
        min_investor: "",
        min_deposit: "",
      },
      submitStatus: "",
      errorResponse: {},
      id_configuration: `${this.$route.params.id}`,
      isDisabled: false,
    };
  },
  created() {
    document.title = "Update Configuration - Manager Cabang";
  },
  validations: {
    payload: {
      ib_level: {
        required,
      },
      min_investor: {
        required,
        numeric,
      },
      min_deposit: {
        required,
        numeric,
      },
    },
  },
  components: {
    ContentHeader,
  },

  async mounted() {
    try {
      let cpConfiguration = await apiClient.get(
        `/configurations/${this.id_configuration}/`
      );
      this.payload = cpConfiguration.data.data;
    } catch (error) {
      this.$toasted.show(error.message, {
        theme: "toasted-primary",
        position: "top-right",
        duration: 4000,
      });
    }
  },

  methods: {
    async handleUpdateData() {
      let data = new FormData();

      data.append("ib_level", this.payload.ib_level);
      data.append("min_investor", this.payload.min_investor);
      data.append("min_deposit", this.payload.min_deposit);

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";

        try {
          await apiClient.put(
            `/configurations/${this.id_configuration}/`,
            data
          );

          this.$swal(
            "Edited!",
            "Configuration has been Edited.",
            "success"
          ).then(() => {
            this.submitStatus = "OK";
            this.$router.push({ name: "ListConfiguration" });
          });
          this.isDisabled = false;
        } catch (e) {
          this.submitStatus = "ERROR";
        }
      }
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.footer-card{
  flex-direction: column-reverse;
}
.bg-grey{
  background-color: #e9ecef !important;
}
@media (min-width: 767px) {
  .footer-card{
    flex-direction: initial;
  }
}

</style>